import vuex from "src/vuex"
import UserRole from "src/util/valueObjects/userRole";
import * as Cookies from "js-cookie";

export default (to, from, next) => {
  const taker_roles = [
    UserRole.TAKER.index,
    UserRole.TRANSPORTER.index,
    UserRole.SHIPPER.index
  ];

  if (!taker_roles.includes(Cookies.getJSON("token").user.role.id))
    vuex.dispatch("redirectToMainMenu");

  next();
};
